import "./Style/App.css"
import { useState, useEffect } from "react";

import config from "./Config/config";
import Hash from "./Utility/Hash"

// import TableContainer from './Component/TableContainer';

import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { routes } from "./Router/router";
import Menu from './View/Menu';



function App() {

  const [isValid, setIsValid] = useState(false);

  const PromptValidate = () => {
    //console.log("useEffect2");
    while (!isValid) {
      //console.log("useEffect3");
      let login = window.prompt("Password:");
      if (Hash(login) === config.hash) {
        //console.log("Pass");
        setIsValid(true);
        break;
      } else {
        //console.log("Fail");
        continue;
      }
    }

  }

  useEffect(() => {
    document.title = "TL Viewer";
    //console.log("useEffect");
    PromptValidate();
    // eslint-disable-next-line
  }, []);










  //if (isValid === !false) { return <div></div> }
  if (isValid === false) { return <div></div> }
  else {
    return (

      <div className="content">

        <BrowserRouter>

          {/* <Menu /> */}


          <Routes>
            {routes.map(route => {
              return (
                <Route
                  path={route.path}
                  key={route.name}
                  element={route.path === "/" ? <route.component defaultpath={route.defaultpath} /> : <route.component />}
                />)
            }
            )

            }


          </Routes>

        </BrowserRouter>
      </div>



    );
  }

}

export default App;
